const sideBarMenu = [
  {
    title : "Dashboard",
    route: "/dashboard",
    isActive : true
  },
  {
    title : "Analytics",
    route: "/analytics",
    isActive : false
  },
  {
    title : "Create Quiz",
    route: "create-quiz",
    isActive : false
  },
];
export { sideBarMenu };
